<p-message
  severity="info"
  icon="pi pi-info-circle"
  styleClass="customInfoMessage"
  tabindex="0"
  role="note"
>
  @if (labelHTML()) {
    <div [innerHTML]="labelHTML() | textResource | async | safeHtml"></div>
  } @else if (label()) {
    {{ label() }}
  } @else {
    <ng-content></ng-content>
  }
</p-message>
